import type { DeployGroupOption, OsFamily, PackageId } from './deployAgentTypes';

// TODO(api): replace with wazuhAPI.getAgentGroups()
export const DEPLOY_AGENT_GROUPS: DeployGroupOption[] = [
  { id: 'default', label: 'default' },
  { id: 'edr', label: 'EDR' },
  { id: 'cl0100', label: 'cl0100' },
  { id: 'okd-102', label: 'okd-102' },
  { id: 'vmtestab', label: 'VMTestAB' },
];

// TODO(api): replace with backend default manager address
export const DEFAULT_SERVER_ADDRESS = '10.1.16.61';

export const MINDTIME_CONTACT_URL =
  'https://mindtime.nl/contact/';

export const OS_PACKAGE_OPTIONS: Record<
  OsFamily,
  { id: PackageId; label: string }[]
> = {
  linux: [
    { id: 'rpm-amd64', label: 'RPM amd64' },
    { id: 'rpm-aarch64', label: 'RPM aarch64' },
    { id: 'deb-amd64', label: 'DEB amd64' },
    { id: 'deb-aarch64', label: 'DEB aarch64' },
  ],
  windows: [{ id: 'msi-32-64', label: 'MSI 32/64 bits' }],
  macos: [
    { id: 'intel', label: 'Intel' },
    { id: 'apple-silicon', label: 'Apple silicon' },
  ],
};

export const DEPLOY_STEP_TITLES = [
  'Select the package to download and install on your system:',
  'Server address',
  'Optional settings',
  'Run the following commands to download and install the agent:',
  'Start the agent:',
] as const;

export const LINUX_REQUIREMENTS = [
  'You will need administrator privileges to run the commands.',
  'Shell Bash is required.',
] as const;
